module.exports = __webpack_public_path__ + "media/components/country-flag/static/do-3f1a88bf2a3c022d4f930d7579e560cf.svg";